import axios from 'axios';

const api = axios.create({
  baseURL: "https://app-andromeda-get-be-f2fwhsgsbehmagf0.westus3-01.azurewebsites.net",
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('token');
      window.location = '/'; // Redirige a la página de login
    }
    return Promise.reject(error);
  }
);

export default api;


